import React, {useEffect} from 'react';
import {index} from '../utils';

const CompressionControl = (props) => {


	const setItem = ($el, $wrapper, itemHeight) => {
		$wrapper.style.marginTop = '-'+ (itemHeight * (index($el) -1)) + 'px';
	};

	useEffect(() => {
		const $compressionControl = document.querySelector('.compression-control');
		const $compressionItemWrap = $compressionControl.querySelector('.compression-item-wrap');
		const $compressionSelect = document.querySelector('.compression-select');
		
		let $items = $compressionControl.querySelectorAll('.compression-item');
		let itemHeight = parseFloat(getComputedStyle($items[0], null).height.replace("px", ""))
		
		let $defaultItem = $compressionControl.querySelector('[data-item='+$compressionSelect.value+']');
		setItem($defaultItem,$compressionItemWrap,itemHeight);


		$items.forEach((el) => {
			el.addEventListener('click', (event) => {
				let clickedElem;
				if(event.target.nodeName === 'SPAN') {
					clickedElem = event.target.parentNode;
				} else {
					clickedElem = event.target;
				}
				
				let clickedCompress = clickedElem.getAttribute('data-item');
				let $newItem = $compressionControl.querySelector('[data-item='+clickedCompress+']');
				setItem($newItem,$compressionItemWrap,itemHeight);

				$compressionSelect.value = clickedCompress;
			});
		});

	});

  return (
	  <React.Fragment>
			<div className="compression-control">
				<div className="compression-item-wrap">
					<div className="compression-item" data-item="ko">
						<span>KO</span>kilo-octet(s)
					</div>
					<div className="compression-item" data-item="mo">
						<span>MO</span>mega-octet(s)
					</div>
					<div className="compression-item" data-item="go">
						<span>GO</span>giga-octet(s)
					</div>
					<div className="compression-item" data-item="to">
						<span>TO</span>tera-octet(s)
					</div>
				</div>
			</div>
			<select name="compression" defaultValue="mo" className="compression-select hidden-select">
				<option value="ko">KO kilo-octet(s)</option>
				<option value="mo">MO mega-octet(s)</option>
				<option value="go">GO giga-octet(s)</option>
				<option value="to">TO tera-octet(s)</option>
			</select>
	</React.Fragment>
  );
}

export default CompressionControl;
